<template>
  <div>
    <ReducedebtHeader header="คลังเสร็จสิ้นการลดหนี้" :img_header="header_image" link_back="stock/storage/reducedebt"/>
    <Reduce_debt_success/>
  </div>
</template>

<script>
import ReducedebtHeader from "@/components/admin/stock/storage_reducedebt/header_reducedebt/ReducedebtHeader";
import Reduce_debt_success from "@/components/admin/stock/storage_reducedebt/Reduce_debt_success";
import HeaderImage from "@/assets/received.png";
export default {
  name: "ReduceDebtSuccess",
  components: {
    Reduce_debt_success,
    ReducedebtHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>